import { getHostHub } from 'owa-config/lib/getHostHub';
import { isHostedCalendar } from 'owa-config/lib/isHostedCalendar';
import { TEAMS_HUB } from 'owa-config/lib/types/HostApp';
import isDeepLink from 'owa-url/lib/isDeepLink';

/**
 * Checks whether Time Panel feature is available in current OWA user/window context.
 *
 * OWA features that interact with Time Panel should implement a graceful fallback to handle
 * contexts where Time Panel is not available, e.g. clicking on 'Show Conflicts' in a
 * meeting invite can fallback to showing a short inline summary in contexts where opening
 * Time Panel to Conflicts View is not an option.
 *
 * IMPORTANT: If access to To Do features is also needed, call `isTimePanelWithToDoFeaturesAvailable(mailboxInfo)`
 * util instead.
 */
export function isTimePanelAvailable(): boolean {
    if ((isHostedCalendar() && getHostHub() === TEAMS_HUB) || (isDeepLink() && window.opener)) {
        return false;
    }
    return true;
}
